<template>
    <div :class="wrapperClass">
        <label v-if="label" class="form-label-alt">
            <span>{{ label }}</span>
            <FieldTooltip :content="tooltipHtml"/>
        </label>
        <textarea
            class="form-control"
            :class="{ 'is-invalid': isInvalid }"
            :value="modelValue"
            :placeholder="placeholder"
            :rows="rows"
            :required="required || undefined"
            :data-parsley-recommended="recommended ? 'true' : undefined"
            :data-parsley-validate-if-empty="recommended ? 'true' : undefined"
            :data-parsley-no-focus="recommended ? 'true' : undefined"
            @input="$emit('update:modelValue', $event.target.value)"
        ></textarea>
        <div v-if="hasError" class="form-error">
            <div v-if="required">Dieses Feld ist ein Pflichtfeld.</div>
            <div v-else-if="recommended">Dieses Feld wird empfohlen auszufüllen</div>
        </div>
    </div>
</template>

<script setup>
import {computed, inject, toRef} from 'vue';
import FieldTooltip from './FieldTooltip.vue';
import {useFieldTooltip} from '../useFieldTooltip';

const props = defineProps({
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    /** Field description key, @see FieldDescriptionService::GROUPS */
    tooltip: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    recommended: { type: Boolean, default: false },
    highlight: { type: Boolean, default: false },
    noMargin: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 7 },
});

defineEmits(['update:modelValue']);

const submitted = inject('submitted', { value: false });
const tooltipHtml = useFieldTooltip(toRef(props, 'tooltip'));

const isEmpty = computed(() => !props.modelValue || !props.modelValue.trim());

/** Red outline — always visible when required + empty */
const isInvalid = computed(() => props.required && isEmpty.value);

/** Recommended warning — shown after first submit attempt */
const isRecommendedEmpty = computed(() => props.recommended && isEmpty.value);

/** Error/warning message — only after first submit attempt */
const hasError = computed(() => submitted.value && (isInvalid.value || isRecommendedEmpty.value));

const wrapperClass = computed(() => ({
    'form-highlight': props.required || props.recommended || props.highlight,
    'mb-3': !props.noMargin,
}));
</script>
